export const Placeholder = ({ className = '' }) => {
	return (
		<div className={`placeholder placeholder-elem ${className}`}></div>
	)
}